import axios from 'axios';

// axiosRetry(axios, { retries: 3 });

const baseURL = typeof window !== 'undefined' ? window.origin + '/api' : '/api';

export default axios.create({
    baseURL,
    withCredentials: true
});
